import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';


import LoginForm from '../../Containers/Authentication/LoginForm';
import SignupForm from '../../Containers/Authentication/SignupForm';

import MarketingPage from './MarketingPage';

import NotFound from '../../Containers/Misc/NotFound';
import ForgotPassword from '../Authentication/ForgotPassword';
import ChangePassword from '../User/ChangePassword';
import EmailConfirmationPage from '../Authentication/EmailConfirmationPage';

const MarketingRoutes = () => (
  <div>
    <Switch>
      <Route path="/login" component={LoginForm} />
      <Route path="/signup" component={SignupForm} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/change-password/:resetToken" component={ChangePassword} />
      <Route path="/email-confirmation/:confirmationToken" component={EmailConfirmationPage} />
      <Route exact path="/" component={MarketingPage} />
      <Route component={NotFound} />
    </Switch>
  </div>
);

export default MarketingRoutes;



// WEBPACK FOOTER //
// ./src/Containers/Marketing/MarketingRoutes.js